import { render, staticRenderFns } from "./SectionCreate.vue?vue&type=template&id=23c47ca8&scoped=true&"
import script from "./SectionCreate.vue?vue&type=script&lang=js&"
export * from "./SectionCreate.vue?vue&type=script&lang=js&"
import style0 from "./SectionCreate.vue?vue&type=style&index=0&id=23c47ca8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c47ca8",
  null
  
)

export default component.exports